module.exports = __webpack_public_path__ + "static/img/male-1.61183049.webp";